$(document).ready(function () {
    $('body').TopBtn();
    $('.toggle-caution').Folding({open: true});

    $('.slick').slick({
        dots: true,
    });

    let quick = function(){
        var $menu = $('.quick-menu ul li'),
            $contents = $('.target'),
            btnTop = $('.top');
        var scltop = $(window).scrollTop();

        if (!($('.header').height() <= scltop)) $menu.removeClass('on');
        $menu.on('click','a', function(e){
            e.preventDefault();
            var target = $(this).attr("href"),
                offsetTop = $(target).offset().top;
            var $doc = $('html, body');
            $doc.stop()
                .animate({
                    scrollTop :offsetTop
                }, 800)
        });
        $(window).scroll(function(){
            var scltop = $(window).scrollTop();
            $.each($contents, function(idx, item){
                var $target = $contents.eq(idx),
                    i = idx,
                    targetTop = $target.offset().top;
                if (targetTop <= scltop) {
                    $menu.removeClass('on');
                    $menu.eq(i).addClass('on');
                }
                else if( $('html').height() === $(window).height() + scltop){
                    $menu.removeClass('on');
                    $menu.eq(idx).addClass('on');
                }
                if (!($('.header').height() <= scltop)) $menu.removeClass('on');
            });
            if (scltop >= $('.header').height() ) $('.quick-menu').addClass('fix');
            else $('.quick-menu').removeClass('fix');
        });
        btnTop.on('click', function(e){
            e.preventDefault();
            $('html, body').stop()
                .animate({
                    scrollTop : 0
                },800)
        });
    };
    quick();
});


// WEBPACK FOOTER //
// ./src/js/index.js